import {
  useBlockUserMutation,
  useUnblockUserMutation,
} from 'api/user-domain/user-domain';
import { useTranslation } from 'react-i18next';

export const useBlockUnblockCustomerDrawer = (
  blocked: boolean,
  email: string,
) => {
  const { t } = useTranslation();
  const [blockUser] = useBlockUserMutation();
  const [unblockUser] = useUnblockUserMutation();

  let title,
    submitButtonLabel,
    customerQuestion,
    infoText,
    trigger,
    submitButtonColor;

  if (blocked) {
    title = t('drawer.customerStatusHistoryDrawer.title.unblock');
    submitButtonLabel = t('drawer.customerStatusHistoryDrawer.buttons.unblock');
    customerQuestion = t(
      'drawer.customerStatusHistoryDrawer.customerQuestion.unblock',
      {
        email,
      },
    );
    infoText = t('drawer.customerStatusHistoryDrawer.infoText.unblock');
    trigger = unblockUser;
    submitButtonColor = 'primary';
  } else {
    title = t('drawer.customerStatusHistoryDrawer.title.block');
    submitButtonLabel = t('drawer.customerStatusHistoryDrawer.buttons.block');
    customerQuestion = t(
      'drawer.customerStatusHistoryDrawer.customerQuestion.block',
      {
        email,
      },
    );
    infoText = t('drawer.customerStatusHistoryDrawer.infoText.block');
    trigger = blockUser;
    submitButtonColor = 'error';
  }

  return {
    title,
    submitButtonLabel,
    customerQuestion,
    infoText,
    trigger,
    submitButtonColor,
  };
};
